import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from "@material-ui/core/FormControl";

// @material-ui/icons
import PermIdentity from "@material-ui/icons/PermIdentity";
import AttachMoney from "@material-ui/icons/AttachMoney";
import Cancel from "@material-ui/icons/Cancel";
import Phone from "@material-ui/icons/Phone";
import Info from "@material-ui/icons/Info";
import Close from "@material-ui/icons/Close";
import Link from "@material-ui/icons/Link";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Clearfix from "components/Clearfix/Clearfix.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Switch from "@material-ui/core/Switch";
import CircularProgress from '@material-ui/core/CircularProgress';

import Danger from "components/Typography/Danger.jsx";

import Subscriptions from "views/Components/Subscriptions"
import Payment from "views/Pages/SignupSteps/Payment"
import ToolTipIcon from "views/Components/ToolTipIcon"
import Agreement from "views/Pages/SignupSteps/Agreement"
import SignupProvider from "views/Pages/SignupProvider"
import PmsAccount from "views/Components/PmsAccount"

import SweetAlert from "react-bootstrap-sweetalert";

import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";

import axios from 'axios';
import { API_ROOT, COMPANY_NAME, OTP_LENGTH, TEXT_MESSAGE_NOTE, EMAIL_NOTE, SUPPORT_EMAIL } from 'api-config';
import { getApiHeaders, handleApiResponse, formatTaxId, parsePhoneResponse } from '../../assets/helpers/apiHelper.jsx';
import { verifyPhone, verifyNumberExactLengthExcludeNonNumeric, verifyEmail } from '../../assets/helpers/formHelper.jsx';
import { getUserGroups } from '../../assets/helpers/utilityHelper.jsx';

import { convertToDisplayDate } from "../../assets/helpers/dataHelper";

const usStateList = require('../../assets/selectLists/usStates.json');

const style = {
  icon: {
    color: "#333333",
    margin: "10px auto 0",
    width: "130px",
    height: "130px",
    border: "1px solid #E5E5E5",
    borderRadius: "50%",
    lineHeight: "174px",
    "& svg": {
      width: "55px",
      height: "55px"
    },
    "& .fab,& .fas,& .far,& .fal,& .material-icons": {
      width: "55px",
      fontSize: "55px"
    }
  },
  ...userProfileStyles,
  ...regularFormsStyle,
  ...sweetAlertStyle
};

var userGroups = getUserGroups()

class UserProfile extends React.Component {

  constructor(props) {
    super(props);
    this._isMounted = false;
    var userId = ''
    var organizationId = '';
    var parentType = ''
    var employerId = ''
    var inDialog = false
    var formControlMargin = 'none'
    var customInputStyle = ''
    var userType = '' //this is the user type of the active user in the UserProfile view, not necessarily the user taking the actions on the account
    if (props.userId) {
      userId = props.userId
      organizationId = sessionStorage.getItem('userId')
    } else {
      userId = sessionStorage.getItem('userId')
    }
    var editByOrg = false
    if (props.editByOrg) {
      editByOrg = true
    }
    if (props.parentType) {
      parentType = props.parentType
    }
    if (props.employerId) {
      employerId = props.employerId
    }
    if (props.inDialog) {
      inDialog = props.inDialog
      formControlMargin = 'dense'
      customInputStyle = {marginTop: "24px"}
    }
    this.onSubmitAddress = this.onSubmitAddress.bind(this);
    this.onSubmitPhone = this.onSubmitPhone.bind(this);
    this.onAccountStatusChange = this.onAccountStatusChange.bind(this);
    this.onSubmitOrganizationTaxInfo = this.onSubmitOrganizationTaxInfo.bind(this);

    var showPlanOptions = '';
    var showPmsAccount = false;
    var showFirstAndLastName = '';
    var lookUpShowCreditCardInput = '';
    var accountStatusTextDetails = '';
    var showOrganizationInfo = '';
    var showProfileInfo = true;
    var showPhoneInfo = true;
    var showBankInfo = true;
    var showAccountInfo = true;
    var showCancelInfo = true;
    var showProviderSignupInfo = false
    var restrictedInputDisabled = '';
    var showEmployerInfo = true
    var showDentistFields = false
    if (userGroups.indexOf('assessment') >= 0) {
      showOrganizationInfo = false
      showProfileInfo = false
      showPhoneInfo = false
      showBankInfo = false
      showAccountInfo = false
      showCancelInfo = false
      showProviderSignupInfo = true
    } else if (userGroups.indexOf('patient') >= 0 || props.userType === 'patient') {
      showPlanOptions = true;
      showFirstAndLastName = true
      accountStatusTextDetails = 'Please be sure to check with your dentist about whether you have anything due for services you have already received. ' +
        'Once you cancel, your dentist will no longer be able to bill you via ' + COMPANY_NAME + '.'
      showOrganizationInfo = false
      restrictedInputDisabled = false
      userType = 'patient'
      lookUpShowCreditCardInput = true
    } else {
      showPlanOptions = false;
      showFirstAndLastName = false
      restrictedInputDisabled = true
      showOrganizationInfo = true
      if (userGroups.indexOf('employer') >= 0 || props.userType === 'employer') {
        accountStatusTextDetails = 'When you cancel, we will automatically cancel your employee subscriptions. ' +
          'We will also send each employee an email with information about how to subscribe to ' + COMPANY_NAME + ' with ' +
          'an individual subscription.'
        userType = 'employer'
      } else {
        accountStatusTextDetails = 'When you cancel, you will no longer show up as an option for patients to search, and you will no longer receive patient subscription fees. ' +
          'Any fees currently due to you will be processed on the regular schedule.'
        showDentistFields = true
      }
      lookUpShowCreditCardInput = false
    }
    if (parentType === 'employer') {
      showEmployerInfo = false
    } else if (parentType === 'provider' && editByOrg) {
      showPmsAccount = true;
    }

    this.state = {
      userId: userId,
      organizationId: organizationId,
      firstName: '',
      lastName: '',
      address1: '',
      address2: '',
      addressCity: '',
      addressState: '',
      addressZip: '',
      email: '',
      username: '',
      phone: '',
      cellphone: '',
      routingNumber: '',
      accountNumber: '',
      accountNumber2: '',
      accountNumberDisplay: '',
      accountNumber2Display: '',
      accountType: '',
      bankName: '',
      inputDisabled: true,
      restrictedInputDisabled: restrictedInputDisabled,
      showPlanOptions: showPlanOptions,
      showPmsAccount: showPmsAccount,
      showFirstAndLastName: showFirstAndLastName,
      accountStatusTextDetails: accountStatusTextDetails,
      openAccount: '',
      acknowledgedDatetime: '',
      cancellationDate: '',
      accountStatusButton: 'cancel',
      accountStatusMessage: '',
      accountStatusButtonDisabled: false,
      showOrganizationInfo: showOrganizationInfo,
      showProfileInfo: showProfileInfo,
      showPhoneInfo: showPhoneInfo,
      showBankInfo: showBankInfo,
      showAccountInfo: showAccountInfo,
      showCancelInfo: showCancelInfo,
      showProviderSignupInfo: showProviderSignupInfo,
      taxId: '',
      taxClassification: '',
      organizationInfo: [],
      taxClassificationOptions: [],
      editByOrg: editByOrg,
      otpDialogueOpen: false,
      otp: '',
      otpDialogueText: '',
      parentType: parentType,
      allowChildAccess: false,
      allowChildAccessStatus: '',
      allowChildAccessStatusIndicator: '',
      allowChildAccessLockFields: true,
      employerId: employerId,
      showDentistFields: showDentistFields,
      showEmployerInfo: showEmployerInfo,
      parentOrgType: '',
      parentName: '',
      parentId: '',
      alert: '',
      userType: userType,
      lookUpShowCreditCardInput: lookUpShowCreditCardInput,
      agreementDialogOpen: false,
      providerSignupDialogOpen: false,
      inDialog: inDialog,
      formControlMargin: formControlMargin,
      customInputStyle: customInputStyle,
      pmsIntegration: false,
      paymentMethod: ''
    }
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleChangeSelect = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  onSubmitAddress(e) {
    e.preventDefault();
    this.setState({responseMessageAddress: 'submitting'})
    const addressData = {
      userId: this.state.userId,
      address1: this.state.address1,
      address2: this.state.address2,
      addressCity: this.state.addressCity,
      addressState: this.state.addressState,
      addressZip: this.state.addressZip
    }
    axios.post(`${API_ROOT}/address/`, addressData, {headers: getApiHeaders()})
      .then(res => handleApiResponse(res));
    const userData = {
      userId: this.state.userId,
      first_name: this.state.firstName,
      last_name: this.state.lastName,
      email: this.state.email
    }
    axios.post(`${API_ROOT}/user/`, userData, {headers: getApiHeaders()})
      .then(res => handleApiResponse(res));

  }

  onSubmitPhone(e) {
    e.preventDefault();
    if (this.state.phone !== '' && !verifyPhone(this.state.phone)) {
      alert("Please enter a valid phone number.")
    } else if (this.state.cellphone !== '' && !verifyPhone(this.state.cellphone)) {
      alert("Please enter a valid cell phone number.")
    } else {
      const phoneInfo = {
        phone: this.state.phone,
        cellphone: this.state.cellphone
      }
      const phoneData = {
        userId: this.state.userId,
        phoneInfo: JSON.stringify(phoneInfo)
      }
      axios.post(`${API_ROOT}/phone/`, phoneData, { headers: getApiHeaders() })
        .then(res => handleApiResponse(res));
    }
  }

  onAccountStatusChange(e) {
    e.preventDefault();
    this.setState({
      accountStatusButtonDisabled: false,
      accountStatusButton: 'updating'
    });
    var openAccount = ''
    if (this.state.openAccount === true) {
      openAccount = false
    } else {
      openAccount = true
    }
    const accountStatusData = {
      userId: this.state.userId,
      openAccount: openAccount
    }
    axios.post(`${API_ROOT}/accountStatus/`, accountStatusData, { headers: getApiHeaders() })
      .then(res => this.setAccountStatus({responseMessage: res.data}));
  }

  onSubmitOrganizationTaxInfo(e) {
    e.preventDefault();
    if (this.state.taxId && !verifyNumberExactLengthExcludeNonNumeric(this.state.taxId,9)) {
      alert("Please enter a 9-digit tax ID number. We did not save your changes.")
    } else {
      const organizationInfo = this.state.organizationInfo
      organizationInfo.taxId = this.state.taxId
      organizationInfo.taxClassification = this.state.taxClassification
      this.setState({
        organizationInfo: organizationInfo
      });
      this.updateOrganizationalInfo()
    }
  }

  updateOrganizationalInfo() {
    const orgData = {
      userId: this.state.userId,
      taxId: this.state.organizationInfo.taxId,
      taxClassification: this.state.organizationInfo.taxClassification,
      showInSearch: this.state.organizationInfo.showInSearch,
      acceptCreditCards: this.state.organizationInfo.acceptCreditCards,
      allowMonthlyPlans: this.state.organizationInfo.allowMonthlyPlans,
      allowAnnualPlans: this.state.organizationInfo.allowAnnualPlans
    }
    axios.post(`${API_ROOT}/organizationInfo/`, orgData, { headers: getApiHeaders() })
      .then(res => handleApiResponse(res));

  }

  componentDidMount() {
    this._isMounted = true;
    axios.get(`${API_ROOT}/user/?userId=`+this.state.userId, {headers: getApiHeaders()})
        .then(res => this.setUserValues({responseMessage: res.data}));

    if (this.state.showProfileInfo) {
      axios.get(`${API_ROOT}/address/?userId=` + this.state.userId, { headers: getApiHeaders() })
        .then(res => this.setAddressValues({ responseMessage: res.data }));
    }

    if (this.state.showAccountInfo) {
      axios.get(`${API_ROOT}/accountStatus/?userId=` + this.state.userId, { headers: getApiHeaders() })
        .then(res => this.setAccountStatus({ responseMessage: res.data }));
    }

    if (this.state.showPhoneInfo) {
      axios.get(`${API_ROOT}/phone/?userId=` + this.state.userId, { headers: getApiHeaders() })
        .then(res => this.setPhoneValues({ responseMessage: res.data }));
    }

    if (this.state.showOrganizationInfo === true) {
      axios.get(`${API_ROOT}/organizationInfo/?userId=` + this.state.userId, { headers: getApiHeaders() })
        .then(res => this.setOrganizationInfo({ responseMessage: res.data }));

      axios.get(`${API_ROOT}/organizationTypes/`, { headers: getApiHeaders() })
        .then(res => this.setOrganizationTaxClassifications({ responseMessage: res.data }));

    }
    if (this.state.showEmployerInfo) {
      this.getEmployerInfo()
    }
    if (this.state.showPmsAccount) {
      this.checkForPmsIntegration()
    }
    this.setState({inputDisabled: false, allowChildAccessLockFields: false})
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getEmployerInfo() {
    axios.get(`${API_ROOT}/parentAccount/?userId=` + this.state.userId + `&orgType=E`, { headers: getApiHeaders() })
      .then(res => this.setEmployerInfo({ responseMessage: res.data }));
  }

  setUserValues(userData) {
    if (this._isMounted) {
      if (!userData.responseMessage.error) {
        var username = ''
        var allowChildAccess = false
        if (verifyEmail(userData.responseMessage.username)) {
          username = userData.responseMessage.username
          allowChildAccess = true
        }
        this.setState({
          firstName: userData.responseMessage.first_name,
          lastName: userData.responseMessage.last_name,
          email: userData.responseMessage.email,
          username: username,
          allowChildAccess: allowChildAccess
        });
      }
    }
  }
  setAddressValues(addressData) {
    if (this._isMounted) {
      if (!addressData.responseMessage.error) {
        this.setState({
          address1: addressData.responseMessage.address1,
          address2: addressData.responseMessage.address2,
          addressCity: addressData.responseMessage.city,
          addressState: addressData.responseMessage.state,
          addressZip: addressData.responseMessage.zip,
        });
      }
    }
  }

  setPhoneValues(phoneData) {
    if (this._isMounted) {
      if (!phoneData.responseMessage.error) {
        const phoneArray = parsePhoneResponse(phoneData.responseMessage)
        if (phoneArray['cellphone'] === '' && this.state.restrictedInputDisabled) {
          this.setState({
            restrictedInputDisabled: false
          });
        }
        this.setState({
          phone: phoneArray['phone'],
          cellphone: phoneArray['cellphone']
        });
      }
    }
  }

  setOrganizationInfo(organizationInfoData) {
    if (this._isMounted) {
      if (!organizationInfoData.responseMessage.error) {
        this.setState({
          taxId: formatTaxId(organizationInfoData.responseMessage.taxId),
          taxClassification: organizationInfoData.responseMessage.taxClassification,
          organizationInfo: organizationInfoData.responseMessage
        });
      }
    }
  }

  setOrganizationTaxClassifications(taxClassificationData) {
    if (this._isMounted) {
      this.setState({
        taxClassificationOptions: taxClassificationData.responseMessage
      })
    }
  }

  setEmployerInfo(res) {
    if (this._isMounted) {
      var parentId = ''
      var parentName = ''
      var employerId = ''
      if (res.responseMessage[0]) {
        parentId = res.responseMessage[0]['organizationId']
        parentName = res.responseMessage[0]['name']
        employerId = res.responseMessage[0]['organizationId']
      }
      this.setState({
        parentId: parentId,
        parentName: parentName,
        employerId: employerId,
        parentOrgType: 'E'
      })
    }
  }

  checkForPmsIntegration() {
    axios.get(`${API_ROOT}/connectedAccount/?userId=` + this.state.organizationId + `&category=pms&boolean=true`, { headers: getApiHeaders() })
      .then(res => this.setPmsIntegration(res.data));
  }

  setPmsIntegration(res) {
    if (res['status']) {
      this.setState({
        pmsIntegration: true
      });
    }
  }

  leaveParentGroupConfirm() {
    var leaveAlertText = ''
    if (this.state.editByOrg) {
      leaveAlertText = 'Are you sure the member wants to leave the ' + this.state.parentName + ' group? ' +
        'If they leave they will be responsible for covering the full cost of the subscription and they may need to select a new subscription. ' +
        'Additionally, their account will be suspended until they log in to sign the member agreement and update account information.'
    } else {
      leaveAlertText = 'Are you sure you want to leave the ' + this.state.parentName +' group? ' +
        'If you leave you will be responsible for covering the full cost of your subscription and you may need to select a new subscription.'
    }
    this.setState({
      alert: (
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title="leave group"
          onConfirm={() => this.leaveParentGroup()}
          onCancel={() => this.hideAlert()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.success
          }
          cancelBtnCssClass={
            this.props.classes.button + " " + this.props.classes.danger
          }
          confirmBtnText="Yes, leave group"
          cancelBtnText="Cancel"
          showCancel
          id="leaveParentGroupAlert"
        >
          <span id="leaveParentGroupAlertText">{leaveAlertText}</span>
        </SweetAlert>)
    });
  }

  leaveParentGroup() {
    this.setState({
      alert: (
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title="leave group"
          onConfirm={() => this.hideAlert()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.success
          }
          confirmBtnText="close"
          id="leaveParentGroupAlert"
        >
          <span id="leaveParentGroupAlertText"><CircularProgress/>leaving...</span>
        </SweetAlert>)
    });
    const updatePatientData = {
      userId: this.state.userId,
      orgUserId: this.state.parentId,
      orgType: this.state.parentOrgType,
      updateAction: 'remove',
      clearInformation: true,
      isPrimary: 1
    }
    axios.post(`${API_ROOT}/childAccount/`, updatePatientData, { headers: getApiHeaders() })
      .then(res => this.handleLeaveParentGroupResponse(res));

  }

  handleLeaveParentGroupResponse(res) {
    if (this._isMounted) {
      if (res.data['message'] === 'success') {
        if (this.state.parentType === '') { //only reset the storage and force re-entering info if the user taking the action is the member
          sessionStorage.setItem('agreementAcknowledged', 'false');
          sessionStorage.setItem('planId', '');
          sessionStorage.setItem('bankAccountSet', 'false');
          window.location.reload();
        } else {
          this.getEmployerInfo()
          this.hideAlert()
        }
      } else {
        this.setState({
          alert: (
            <SweetAlert
              style={{ display: "block", marginTop: "-100px" }}
              title="leave group"
              onConfirm={() => this.hideAlert()}
              confirmBtnCssClass={
                this.props.classes.button + " " + this.props.classes.success
              }
              confirmBtnText="close"
              id="leaveParentGroupAlert"
            >
              <span id="leaveParentGroupAlertText">There was an error updating your account. Please contact your employer or email {SUPPORT_EMAIL}.</span>
            </SweetAlert>)
        });
      }

    }
  }

  hideAlert() {
    this.setState({
      alert: null
    });
  }

  setAccountStatus(accountStatusData) {
    if (this._isMounted) {
      if (!accountStatusData.responseMessage.error) {
        const openAccount = accountStatusData.responseMessage['openAccount']
        var acknowledgedDatetime = ''
        var cancellationDate = ''
        if (openAccount === true) {
          var accountStatusButton = 'cancel'
          var accountStatusMessage = 'Your account is currently active.'
        } else {
          accountStatusButton = 're-activate account'
          accountStatusMessage = 'Your account is currently inactive.'
        }
        if (accountStatusData.responseMessage['acknowledgedDatetime']) {
          acknowledgedDatetime = convertToDisplayDate(accountStatusData.responseMessage['acknowledgedDatetime'])
        } else {
          acknowledgedDatetime = 'NOT YET SIGNED'
        }
        if (accountStatusData.responseMessage['cancellationDate']) {
          cancellationDate = convertToDisplayDate(accountStatusData.responseMessage['cancellationDate'])
        } else {
          cancellationDate = ''
        }

        this.setState({
          accountStatusMessage: accountStatusMessage,
          accountStatusButton: accountStatusButton,
          openAccount: openAccount,
          acknowledgedDatetime: acknowledgedDatetime,
          cancellationDate: cancellationDate
        });

      }
    }
  }

  getOtpOpen() {
    this.setState({
      otpDialogueOpen: true,
      otpDialogueText: "Please click the button to get a one-time password via text message. It will go to the cell phone linked to your account."
    })
  }

  getOtp(reason) {
    axios.get(`${API_ROOT}/otp/?reason=` + reason, { headers: getApiHeaders() })
      .then(res => this.setOtpRes({ responseMessage: res.data }));
  }

  setOtpRes(res) {
    var otpDialogueText = ''
    if (res.responseMessage['message'] && res.responseMessage['message'] === 'success') {
      otpDialogueText='We just sent you a ' + OTP_LENGTH + '-digit one-time password to the cell phone linked to your account.\n' +
        'Please enter it to edit your info.'
    } else {
      otpDialogueText = 'ERROR: ' + res.responseMessage['error']
    }

    this.setState({
      otpDialogueText: otpDialogueText
    })
  }

  handleOtpDialogEnter(reason) {
    const otpData = {
      reason: reason,
      otp: this.state.otp
    }
    axios.post(`${API_ROOT}/otp/`, otpData, { headers: getApiHeaders() })
      .then(res => this.setOtpEntryResponse({responseMessage: res.data}));
  }

  setOtpEntryResponse(res) {
    if (res.responseMessage['message'] && res.responseMessage['message'] === 'success') {
      this.setState({
        restrictedInputDisabled: false
      })
      this.handleOtpDialogClose()
    } else {
      this.setState({
        otpDialogueText: "The one-time password you entered is not valid. " +
                          "To be valid, the password must be unused, no more than 5-minutes old, " +
                          "and you must have requested it from the same computer where you are entering it. " +
                          "You can try reentering it or request a new password."
      })
    }
  }

  handleOtpDialogClose() {
    this.setState({
      otpDialogueOpen: false,
      otp: '',
      otpDialogueText: ''
    });
  };

  handleShowSignedAgreement() {
    this.setState({
      agreementDialogOpen: true
    });
  }

  handleHideSignedAgreement() {
    this.setState({
      agreementDialogOpen: false
    });
  }

  handleShowProviderSignup() {
    this.setState({
      providerSignupDialogOpen: true
    });
  }

  handleHideProviderSignup() {
    this.setState({
      providerSignupDialogOpen: false
    });
  }

  handleAllowChildAccessToggle = name => event => {
    var updateToggle = true
    var statusMessage = ''
    var statusIndicator = ''
    var lockFields = false
    const allowAccess = event.target.checked
    //validate that the user entered an email address for the username if they are trying to grant access
    if (allowAccess === true && (verifyEmail(this.state.username) === false || this.state.username === '')) {
      statusMessage = 'you need to enter a valid email address for the username before you can grant access to the member'
      updateToggle = false
    }

    //proceed only if we have passed the above test to change the toggle
    if (updateToggle === true) {
      //update the toggle display
      this.setState({ [name]: allowAccess });
      const allowAccesData = {
        userId: this.state.userId,
        email: this.state.username,
        allowAccess: allowAccess
      }
      axios.post(`${API_ROOT}/childAccountAccess/`, allowAccesData, { headers: getApiHeaders() })
        .then(res => this.setAllowAccessToggleResponse({responseMessage: res.data}, allowAccess));
      statusMessage = 'updating...'
      statusIndicator = <CircularProgress size={20}/>
      lockFields = true
    }

    this.setState({
      allowChildAccessStatus: statusMessage,
      allowChildAccessStatusIndicator: statusIndicator,
      allowChildAccessLockFields: lockFields
    });

  };

  setAllowAccessToggleResponse(res) {
    var statusMessage = ''
    if (res.responseMessage.error) {
      statusMessage = res.responseMessage.error
    } else if (res.responseMessage.message) {
      statusMessage = res.responseMessage.message
      //don't display a message if success - just remove the updating message
      if (statusMessage === 'success') {
        statusMessage = ''
      }
    } else {
      statusMessage = 'An unknown error occurred and your update may have not saved. ' +
                      'Please try again. Email ' + SUPPORT_EMAIL + ' if this issue continues.'
    }

    if (statusMessage) {
      //if the action was not successful, set the toggle back to its state prior to the action
      this.setState({
        allowChildAccess: !this.state.allowChildAccess
      });
    } else if (this.state.allowChildAccess === true) {
      //if it was successful and allow access is true, update the user's email in the UI since that backend update occurred
      this.setState({
        email: this.state.username
      });
    }
    this.setState({
      allowChildAccessStatus: statusMessage,
      allowChildAccessStatusIndicator: '',
      allowChildAccessLockFields: false
    });

  }

  updateStateFromChild(stateName, value) {
    this.setState({ [stateName]: value });
  }

  render() {
    const { classes } = this.props;
    var subscriptions = ''
    if (this.state.showPlanOptions) {
      subscriptions = <Subscriptions
        userId={this.state.userId}
        editByOrg={this.state.editByOrg}
        employerId={this.state.employerId}
        paymentMethod={this.state.paymentMethod}
      />
    }
    return (
      <div>
        <GridContainer style={this.state.showProfileInfo ? {} : { display: 'none' }}>
          {this.state.alert}
          <Dialog
            open={this.state.otpDialogueOpen}
            onClose={this.handleClose}
            aria-labelledby="form-dialog-title"
            maxWidth='sm'
            width='sm'
          >
            <DialogTitle id="form-dialog-title">enter one-time password</DialogTitle>
            <DialogContent>
              <Button onClick={this.getOtp.bind(this, 'userInfoChange')} color="cirrusBlue">
                send one-time password
              </Button>
              <br/>
              {this.state.otpDialogueText}
              <br/>
              <CustomInput
                labelText="one-time password"
                id="otp"
                inputProps={{
                  onChange: this.handleChange,
                  value: this.state.otp
                }}
                customStyle={this.state.customInputStyle}
              />

            </DialogContent>

            <DialogActions>
              <Button onClick={this.handleOtpDialogEnter.bind(this, 'userInfoChange')} color="cirrusBlue">
                Enter
              </Button>
              <Button onClick={this.handleOtpDialogClose.bind(this)} color="cirrusBlue">
                Close
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={this.state.agreementDialogOpen}
            aria-labelledby="form-dialog-title"
            maxWidth='lg'
            width='md'
          >
            <DialogTitle id="form-dialog-title">user agreement</DialogTitle>
              <DialogContent>
                <Agreement
                  showSignedAgreement = {true}
                  signForUserId = {this.state.userId}
                />
              </DialogContent>
            <DialogActions>
              <Button onClick={this.handleHideSignedAgreement.bind(this)} color="cirrusBlue">
                Close
              </Button>
            </DialogActions>


          </Dialog>

          <Dialog
            open={this.state.providerSignupDialogOpen}
            aria-labelledby="form-dialog-title"
            maxWidth='lg'
            width='lg'
          >
            <DialogContent>
              <SignupProvider
                userId = {this.state.userId}
                showPreLoginHeaderAndFooter = {false}
                wizardWidth = "1200px"
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleHideProviderSignup.bind(this)} color="cirrusBlue">
                Close
              </Button>
            </DialogActions>


          </Dialog>

          <GridItem xs={12} sm={12} md={8}>
            <form onSubmit={this.onSubmitAddress}>
              <Card>
                <CardHeader color="cirrusBlue" icon>
                  <CardIcon color="cirrusBlue">
                    <PermIdentity />
                  </CardIcon>
                  <h4 id="userProfileHeader" className={classes.cardIconTitle}>
                    Edit Profile - <small>add or update information</small>
                  </h4>
                </CardHeader>
                <CardBody>

                  <GridContainer style={this.state.showFirstAndLastName ? {} : { display: 'none' }}>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        labelText="first name"
                        id="firstName"
                        formControlProps={{
                          fullWidth: true,
                          margin: this.state.formControlMargin
                        }}
                        inputProps={{
                          onChange: this.handleChange,
                          value: this.state.firstName,
                          disabled: this.state.inputDisabled
                        }}
                        customStyle={this.state.customInputStyle}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        labelText="last name"
                        id="lastName"
                        formControlProps={{
                          fullWidth: true,
                          margin: this.state.formControlMargin
                        }}
                        inputProps={{
                          onChange: this.handleChange,
                          value: this.state.lastName,
                          disabled: this.state.inputDisabled
                        }}
                        customStyle={this.state.customInputStyle}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer style={this.state.showFirstAndLastName ? { display: 'none' } : {}}>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="company name"
                        id="lastName"
                        formControlProps={{
                          fullWidth: true,
                          margin: this.state.formControlMargin
                        }}
                        inputProps={{
                          onChange: this.handleChange,
                          value: this.state.lastName,
                          disabled: this.state.inputDisabled
                        }}
                        customStyle={this.state.customInputStyle}
                      />
                    </GridItem>
                  </GridContainer>


                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>

                      <CustomInput
                        labelText="address"
                        id="address1"
                        formControlProps={{
                          fullWidth: true,
                          margin: this.state.formControlMargin
                        }}
                        inputProps={{
                          onChange: this.handleChange,
                          value: this.state.address1,
                          disabled: this.state.inputDisabled
                        }}
                        customStyle={this.state.customInputStyle}
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="address"
                        id="address2"
                        formControlProps={{
                          fullWidth: true,
                          margin: this.state.formControlMargin
                        }}
                        inputProps={{
                          onChange: this.handleChange,
                          value: this.state.address2,
                          disabled: this.state.inputDisabled
                        }}
                        customStyle={this.state.customInputStyle}
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={4}>
                      <CustomInput
                        labelText="city"
                        id="addressCity"
                        formControlProps={{
                          fullWidth: true,
                          margin: this.state.formControlMargin
                        }}
                        inputProps={{
                          onChange: this.handleChange,
                          value: this.state.addressCity,
                          disabled: this.state.inputDisabled
                        }}
                        customStyle={this.state.customInputStyle}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>


                      <FormControl
                        fullWidth
                        className={classes.selectFormControl}
                      >
                        <InputLabel
                          htmlFor="simple-select"
                          className={classes.selectLabel}
                        >
                          state
                        </InputLabel>
                        <Select
                          MenuProps={{
                            className: classes.selectMenu
                          }}
                          classes={{
                            select: classes.select
                          }}
                          value={this.state.addressState}
                          onChange={this.handleChangeSelect}

                          inputProps={{
                            id: "addressState",
                            name: "addressState",
                            disabled: this.state.inputDisabled

                          }}

                        >
                          <MenuItem
                            disabled
                            classes={{
                              root: classes.selectMenuItem
                            }}
                          >
                            Choose state
                          </MenuItem>
                          {usStateList.map((usState) =>
                            <MenuItem classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected
                            }} key={usState.abbreviation} value={usState.abbreviation} >{usState.name}</MenuItem>
                          )}

                        </Select>
                      </FormControl>

                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                      <CustomInput
                        labelText="ZIP Code"
                        id="addressZip"
                        formControlProps={{
                          fullWidth: true,
                          margin: this.state.formControlMargin
                        }}
                        inputProps={{
                          onChange: this.handleChange,
                          value: this.state.addressZip,
                          disabled: this.state.inputDisabled
                        }}
                        customStyle={this.state.customInputStyle}
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>

                      <CustomInput
                        labelText="email"
                        id="email"
                        formControlProps={{
                          fullWidth: true,
                          margin: this.state.formControlMargin
                        }}
                        inputProps={{
                          onChange: this.handleChange,
                          value: this.state.email,
                          disabled: this.state.inputDisabled
                        }}
                        customStyle={this.state.customInputStyle}
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      {EMAIL_NOTE}
                    </GridItem>
                  </GridContainer>
                  <Button color="cirrusBlue" id="updateProfileButton" className={classes.updateProfileButton} type="submit" disabled={this.state.inputDisabled}>
                    Update Profile
                  </Button>
                  <Clearfix />
                </CardBody>
              </Card>
            </form>
          </GridItem>
        </GridContainer>

        <GridContainer style={this.state.showPhoneInfo ? {} : { display: 'none' }}>
          <GridItem xs={12} sm={12} md={8}>
            <form onSubmit={this.onSubmitPhone}>
              <Card>
                <CardHeader color="cirrusBlue" icon>
                  <CardIcon color="cirrusBlue">
                    <Phone />
                  </CardIcon>
                  <h4 className={classes.cardIconTitle}>
                    Edit Phone - <small>add or update phone numbers</small>
                  </h4>
                </CardHeader>
                <CardBody>
                  <div style={this.state.restrictedInputDisabled ? {} : { display: 'none' }}>
                    You need to enter a one-time password to edit phone information.
                    <Button
                      onClick={this.getOtpOpen.bind(this, 'userInfoChange')}
                      color="cirrusBlue"
                      className={classes.updateProfileButton}
                      type="submit"
                      disabled={this.state.inputDisabled}>
                      enter one-time password
                    </Button>
                  </div>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="phone"
                        id="phone"
                        formControlProps={{
                          fullWidth: true,
                          margin: this.state.formControlMargin
                        }}
                        inputProps={{
                          onChange: this.handleChange,
                          value: this.state.phone,
                          disabled: this.state.restrictedInputDisabled
                        }}
                        customStyle={this.state.customInputStyle}
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="cell phone"
                        id="cellphone"
                        formControlProps={{
                          fullWidth: true,
                          margin: this.state.formControlMargin
                        }}
                        inputProps={{
                          onChange: this.handleChange,
                          value: this.state.cellphone,
                          disabled: this.state.restrictedInputDisabled
                        }}
                        customStyle={this.state.customInputStyle}
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      {TEXT_MESSAGE_NOTE}
                    </GridItem>
                  </GridContainer>
                  <Button color="cirrusBlue" className={classes.updateProfileButton} type="submit" disabled={this.state.restrictedInputDisabled}>
                    Update Phone Info
                  </Button>
                  <Clearfix />
                </CardBody>
              </Card>
            </form>
          </GridItem>
        </GridContainer>

        <GridContainer style={this.state.parentType !== 'employer' && this.state.parentName === '' && this.state.showBankInfo ? {} : { display: 'none' }}>
          <GridItem xs={12} sm={12} md={8}>
            <Card>
              <CardHeader color="cirrusBlue" icon>
                <CardIcon color="cirrusBlue">
                  <AttachMoney />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                  Edit Bank - <small>add or update bank account information</small>
                </h4>
              </CardHeader>
              <CardBody>
                <div style={this.state.restrictedInputDisabled ? { display: 'none' } : {}} >
                  <Payment
                    embedded={true}
                    submitAction={'saveNoReload'}
                    userId={this.state.userId}
                    lookUpShowCreditCardInput={this.state.lookUpShowCreditCardInput}
                    inDialog={this.state.inDialog}
                    updateParentState={this.updateStateFromChild.bind(this)}
                  />
                </div>
                <div style={this.state.restrictedInputDisabled ? {} : { display: 'none' }}>
                  You need to enter a one-time password to edit bank information.
                  <Button
                    onClick={this.getOtpOpen.bind(this, 'userInfoChange')}
                    color="cirrusBlue"
                    className={classes.updateProfileButton}
                    type="submit"
                    disabled={this.state.inputDisabled}>
                    enter one-time password
                  </Button>
                </div>
                <Clearfix />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <span style={this.state.pmsIntegration && this.state.showPmsAccount ? {} : { display: 'none' }}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={8}>
              <Card>
                <CardHeader color="cirrusBlue" icon>
                  <CardIcon color="cirrusBlue">
                    <Link />
                  </CardIcon>
                  <h4 className={classes.cardIconTitle}>
                    Edit Practice Management Software link
                  </h4>
                </CardHeader>
                <CardBody>
                  <PmsAccount
                    userId={this.state.userId}
                    organizationId={this.state.organizationId}
                    customInputStyle={this.state.customInputStyle}
                  />
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </span>
        <GridContainer style={this.state.showOrganizationInfo ? {} : { display: 'none' }}>
          <GridItem xs={12} sm={12} md={8}>
            <form onSubmit={this.onSubmitOrganizationTaxInfo}>
              <Card>
                <CardHeader color="cirrusBlue" icon>
                  <CardIcon color="cirrusBlue">
                    <AttachMoney />
                  </CardIcon>
                  <h4 className={classes.cardIconTitle}>
                    Edit Organization Info - <small>add or update organization information</small>
                  </h4>
                </CardHeader>
                <CardBody>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="tax ID"
                        id="taxId"
                        formControlProps={{
                          fullWidth: true,
                          margin: this.state.formControlMargin
                        }}
                        inputProps={{
                          onChange: this.handleChange,
                          value: this.state.taxId,
                          disabled: this.state.inputDisabled
                        }}
                        customStyle={this.state.customInputStyle}
                      />
                    </GridItem>
                  </GridContainer>


                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <FormControl
                        fullWidth
                        className={classes.selectFormControl}
                      >
                        <InputLabel
                          htmlFor="simple-select"
                          className={classes.selectLabel}
                        >
                          tax classification
                        </InputLabel>
                        <Select
                          MenuProps={{
                            className: classes.selectMenu
                          }}
                          classes={{
                            select: classes.select
                          }}
                          value={this.state.taxClassification}
                          onChange={this.handleChangeSelect}

                          inputProps={{
                            id: "taxClassification",
                            name: "taxClassification",
                            disabled: this.state.inputDisabled

                          }}

                        >
                          <MenuItem
                            disabled
                            classes={{
                              root: classes.selectMenuItem
                            }}
                          >
                            choose classification
                          </MenuItem>
                          {this.state.taxClassificationOptions.map((taxClassification) =>
                            <MenuItem classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected
                            }} key={taxClassification[0]} value={taxClassification[0]} >{taxClassification[1]}</MenuItem>
                          )}

                        </Select>
                      </FormControl>
                    </GridItem>
                  </GridContainer>

                  <Button color="cirrusBlue" className={classes.updateProfileButton} type="submit" disabled={this.state.inputDisabled}>
                    Update Organization Info
                  </Button>
                  <Clearfix />
                </CardBody>
              </Card>
            </form>
          </GridItem>
        </GridContainer>
        <span style={this.state.showPlanOptions ? {} : { display: 'none' }}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={8}>
              <Card>
                {subscriptions}
              </Card>
            </GridItem>
          </GridContainer>
        </span>
        <GridContainer style={this.state.showAccountInfo ? {} : { display: 'none' }}>
          <GridItem xs={12} sm={12} md={8}>
            <Card>
              <CardHeader color="cirrusBlue" icon>
                <CardIcon color="cirrusBlue">
                  <Info />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                  Account Information - <small>information about your account</small>
                </h4>
              </CardHeader>
              <CardBody>
                <GridContainer justifyContent="center">
                  <GridItem xs={12} sm={12} md={12} lg={10}>
                    <GridContainer>
                      <GridItem  xs={12} sm={12}>
                        signed agreement on: {this.state.acknowledgedDatetime}
                      </GridItem>
                      <GridItem  xs={12} sm={12} style={this.state.acknowledgedDatetime === 'NOT YET SIGNED' ? { display: 'none' } : {}}>
                        <Button
                          onClick={this.handleShowSignedAgreement.bind(this)}
                          color="cirrusBlue"
                          type="submit"
                          disabled={this.state.inputDisabled}>
                          view
                        </Button>
                      </GridItem>
                      <GridItem  xs={12} sm={12} style={this.state.cancellationDate ? {} : { display: 'none' }}>
                        canceled account on : {this.state.cancellationDate}
                      </GridItem>
                    </GridContainer>


                  </GridItem>
                </GridContainer>
                {/*don't allow the parent user to remove access to their own account*/}
                <GridContainer justifyContent="center" style={this.state.parentType === 'patient' && this.state.userId !== sessionStorage.getItem('userId') ? {} : { display: 'none' }}>
                  <GridItem xs={12} sm={12} md={12} lg={10}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={12}>
                        <hr />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                        To allow the member to access the account, enter their email address and click the toggle to allow access
                        <ToolTipIcon
                          tooltipText="When a member has access to their account, they will be able to view and edit all account information,
                        including changing or canceling their subscription. They will not have access to your account."
                          asAdornment={false}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>

                        <CustomInput
                          labelText="email (username)"
                          id="username"
                          formControlProps={{
                            fullWidth: true,
                            margin: this.state.formControlMargin
                          }}
                          inputProps={{
                            onChange: this.handleChange,
                            value: this.state.username,
                            disabled: this.state.allowChildAccessLockFields
                          }}
                          customStyle={this.state.customInputStyle}
                        />
                      </GridItem>
                      <GridItem  xs={12} sm={12} md={12}>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={this.state.allowChildAccess}
                              onChange={this.handleAllowChildAccessToggle("allowChildAccess")}
                              value="allowChildAccess"
                              id="allowChildAccess"
                              disabled={this.state.allowChildAccessLockFields}
                              classes={{
                                switchBase: classes.switchBase,
                                checked: classes.switchChecked
                              }}
                            />
                          }
                          classes={{
                            label: classes.label
                          }}
                          label="allow member to access account"
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                        <Danger>{this.state.allowChildAccessStatusIndicator} <span id="allowChildAccessStatus">{this.state.allowChildAccessStatus}</span></Danger>
                      </GridItem>
                    </GridContainer>
                  </GridItem>
                </GridContainer>
                <GridContainer justifyContent="center" style={this.state.showEmployerInfo && this.state.parentName !== '' ? {} : { display: 'none' }}>
                  <GridItem xs={12} sm={12} md={12} lg={10}>
                    <GridContainer>
                      <GridItem  xs={12} sm={12}>
                        enrolled in employer subscription with {this.state.parentName}
                        <Button
                          color="danger"
                          simple
                          onClick={this.leaveParentGroupConfirm.bind(this)}
                          id={"leaveParentGroupConfirmButton"}
                          name={"leaveParentGroupConfirmButton"}
                        >
                          <Close/> leave group
                        </Button>
                      </GridItem>
                      {/*<GridItem  xs={12} sm={12} style={this.state.cancellationDate ? {} : { display: 'none' }}>*/}
                        {/*canceled account on : {this.state.cancellationDate}*/}
                      {/*</GridItem>*/}
                    </GridContainer>
                  </GridItem>
                </GridContainer>
                <Clearfix />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <GridContainer style={this.state.showCancelInfo ? {} : { display: 'none' }}>
          <GridItem xs={12} sm={12} md={8}>
            <Card>
              <CardHeader color="cirrusBlue" icon>
                <CardIcon color="cirrusBlue">
                  <Cancel />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                  Cancel Account - <small>cancel your account</small>
                </h4>
              </CardHeader>
              <CardBody>
                <GridContainer justifyContent="center">
                  <GridItem xs={12} sm={12} md={12} lg={10}>
                    <GridContainer>
                      <p style={this.state.openAccount && !this.state.editByOrg ? {} : { display: 'none' }}>We hate to see you go, but it's easy to cancel your account. Just click the cancel button.</p>
                      <p style={this.state.openAccount && !this.state.editByOrg ? {} : { display: 'none' }}>{this.state.accountStatusTextDetails}</p>
                      <p style={this.state.openAccount && !this.state.editByOrg ? {} : { display: 'none' }}>If you want to join us again, just log back in and click the button here to activate your account.</p>
                        <GridItem  xs={12} sm={12}>
                          <form onSubmit={this.onAccountStatusChange}>
                            <Button id="cancelAccountButton" color="cirrusBlue" type="submit" disabled={this.state.accountStatusButtonDisabled}>
                              {this.state.accountStatusButton}
                            </Button>
                          </form>
                          <span id="accountStatusMessage">{this.state.accountStatusMessage}</span>
                        </GridItem>
                    </GridContainer>


                  </GridItem>
                </GridContainer>
                <Clearfix />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>

        <GridContainer style={this.state.showProviderSignupInfo ? {} : { display: 'none' }}>
          <GridItem xs={12} sm={12} md={8}>
            <Card>
              <CardHeader color="cirrusBlue" icon>
                <CardIcon color="cirrusBlue">
                  <Cancel />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                  Account Info - <small>view your account</small>
                </h4>
              </CardHeader>
              <CardBody>
                <GridContainer justifyContent="center">
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    username: {this.state.email}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <Button
                      color="cirrusBlue"
                      id="signUpProviderButton"
                      onClick={this.handleShowProviderSignup.bind(this)}
                      disabled={this.state.inputDisabled}>
                      sign up to offer your patients memberships
                    </Button>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    Once you've determined whether a membership program will work for your practice, click the sign up
                    button and we'll take you through the sign up process. There is no sign up fee or any other sort of
                    fee until you've signed up patients for memberships. You can cancel anytime without penalty if you
                    change your mind. Plus, it's a quick sign up process.
                  </GridItem>
                </GridContainer>
                <Clearfix />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>

      </div>
    )

  }


}

export default withStyles(style)(UserProfile);
